import { useState, useEffect } from 'react';
import { useActiveAccount } from 'thirdweb/react';
import { createPublicClient, http } from 'viem';
import { polygon } from 'viem/chains';
import './GasBanner.css';

const SWAP_URL =
  'https://app.uniswap.org/swap?chain=polygon' +
  '&inputCurrency=0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359' +
  '&outputCurrency=MATIC&exactAmount=0.50&exactField=input';

// Minimum POL balance to suppress the banner (~10 transactions worth of gas)
const MIN_POL = 0.002;

const client = createPublicClient({
  chain: polygon,
  transport: http(),
});

export default function GasBanner() {
  const account = useActiveAccount();
  const [polBalance, setPolBalance] = useState(null); // null = loading
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!account?.address) return;
    let cancelled = false;

    async function fetchBalance() {
      try {
        const bal = await client.getBalance({ address: account.address });
        if (!cancelled) {
          // bal is in wei (BigInt); convert to float POL
          setPolBalance(Number(bal) / 1e18);
        }
      } catch {
        if (!cancelled) setPolBalance(null);
      }
    }

    fetchBalance();
    const interval = setInterval(fetchBalance, 15_000); // refresh every 15s
    return () => { cancelled = true; clearInterval(interval); };
  }, [account?.address]);

  // Don't show if: wallet disconnected, balance loading, balance is fine, or dismissed
  if (!account) return null;
  if (polBalance === null) return null;       // still loading
  if (polBalance >= MIN_POL) return null;     // enough gas
  if (dismissed) return null;

  const polDisplay = polBalance.toFixed(5);

  return (
    <div className="gas-banner">
      <span className="gas-banner__icon">⛽</span>
      <div className="gas-banner__body">
        <strong>No tienes suficiente POL para gas</strong> — tu balance es{' '}
        <strong style={{ color: '#FF4B00' }}>{polDisplay} POL</strong>.
        Las transacciones en Polygon necesitan POL (no USDC) para pagar gas.{' '}
        <a href={SWAP_URL} target="_blank" rel="noopener noreferrer" className="gas-banner__link">
          Swap $0.50 USDC → POL en Uniswap →
        </a>
      </div>
      <button
        className="gas-banner__close"
        onClick={() => setDismissed(true)}
        aria-label="Cerrar aviso"
      >
        ✕
      </button>
    </div>
  );
}
